/**
 * Function does a text match for highlighting matching characters in an autosuggest
 */
export default (text, matchText, matchTag) => {
	let matchIndex;
	let matchLength;
	let textLength;
	let result = { success: false, matchParts: [], formattedText: text };

	//default to use the html <match> tag to highlight text
	matchTag = matchTag || 'mark';

	if (text && matchText) {
		textLength = text.length;
		matchIndex = text.search(new RegExp(matchText, 'gi'));

		if (matchIndex >= 0) {
			result.success = true;
			matchLength = matchText.length;

			if (matchIndex === 0) {
				result.matchParts.push(`<${matchTag}>`);
				result.matchParts.push(text.substring(0, matchLength));
				result.matchParts.push(`</${matchTag}>`);
			} else {
				result.matchParts.push(text.substring(0, matchIndex));
				result.matchParts.push(`<${matchTag}>`);
				result.matchParts.push(
					text.substring(matchIndex, matchIndex + matchLength)
				);
				result.matchParts.push(`</${matchTag}>`);
			}

			if (matchIndex + matchLength < textLength) {
				result.matchParts.push(
					text.substring(matchIndex + matchLength)
				);
			}

			result.formattedText = result.matchParts.join('');
		}
	}

	return result;
};
